import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, Badge } from "react-bootstrap";

/**
 * Modal wyświetlany przy edycji oddziału, gdy zmiana terminali EX/DR
 * wymaga propagacji do wielu rekordów w Informations.
 * Użytkownik może wykonać natychmiast lub zaplanować na konkretną datę.
 */
const BranchTerminalChangeModal = ({
  show,
  onHide,
  onConfirm,
  affectedCount = 0,
  oldEx,
  oldDr,
  newEx,
  newDr,
  submitting,
}) => {
  const [executionDate, setExecutionDate] = useState("");

  const handleConfirmNow = () => {
    if (affectedCount > 500) {
      const confirmed = window.confirm(
        `Zmiana dotyczy ${affectedCount} rekordów.\n\n` +
        "Czy na pewno chcesz wykonać aktualizację oddziału wraz z wszystkimi powiązanymi informacjami dotyczącymi kodów pocztowych natychmiast?\n" +
        "(Czas realizacji zależy od ilości danych do przetworzenia)"
      );
      if (!confirmed) return;
    }
    onConfirm(null); // null = natychmiastowe wykonanie
  };

  const handleConfirmScheduled = () => {
    if (!executionDate) {
      alert("Podaj datę wykonania aktualizacji.");
      return;
    }
    onConfirm(executionDate);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Aktualizacja Oddziału - propagacja do Warstwy Adresowej</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Zmiana terminali z{" "}
          <strong>{oldEx}/{oldDr}</strong> na{" "}
          <strong>{newEx}/{newDr}</strong> wymaga aktualizacji
          istniejących rekordów w bazie.
        </p>

        <Badge bg="warning" text="dark" className="fs-6 p-2 mb-3">
          ⚠ Liczba rekordów do zaktualizowania: {affectedCount}
        </Badge>

        <hr />

        <p className="fw-bold">Wybierz sposób wykonania:</p>

        <Row className="mb-3">
          <Col md={6}>
            <div className="border rounded p-3 h-100">
              <h6>🔄 <b>Wykonaj natychmiast</b></h6>
              <p className="text-muted small mb-2">
                Praca nad aktualizacją oddziału rozpocznie się natychmiast.
                {affectedCount > 500 && (
                  <span className="text-danger">
                    {" "}  <br/>Wykryto dużą liczbę rekordów do przeprocesowania. <br/>Taka operacja może zająć więcej czasu.<br/>
                  </span>
                )}
              </p>
              <Button
                variant="primary"
                onClick={handleConfirmNow}
                disabled={submitting}
                className="w-100"
              >
                {submitting ? "Zapisywanie..." : "Wykonaj teraz"}
              </Button>
            </div>
          </Col>
          <Col md={6}>
            <div className="border rounded p-3 h-100">
              <h6>📅 <b>Zaplanuj wykonanie</b></h6>
              <Form.Group controlId="terminalExecutionDate" className="mb-2">
                <Form.Control
                  type="datetime-local"
                  value={executionDate}
                  onChange={(e) => setExecutionDate(e.target.value)}
                />
                <Form.Text className="text-muted">
                  Aktualizacja zostanie wykonana automatycznie w podanym terminie.
                </Form.Text>
              </Form.Group>
              <Button
                variant="outline-primary"
                onClick={handleConfirmScheduled}
                disabled={submitting || !executionDate}
                className="w-100"
              >
                {submitting ? "Zapisywanie..." : "Zaplanuj"}
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Anuluj
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BranchTerminalChangeModal;
